/**
 * @generated SignedSource<<3507c50f5ab0ae2795417c27d8341a66>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateDeliverableInput = {
  id: string;
  name?: string | null;
  description?: string | null;
  projectId?: string | null;
  price?: number | null;
  clearPrice?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type UpdateDeliverableMutation$variables = {
  input: UpdateDeliverableInput;
};
export type UpdateDeliverableMutation$data = {
  readonly updateDeliverable: {
    readonly deliverable: {
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly description: string | null;
        readonly price: number | null;
        readonly invoicedAmount: number | null;
        readonly lockedRevenue: number | null;
        readonly hasBeenInvoiced: boolean | null;
        readonly hasLockedRevenue: boolean | null;
      } | null;
    } | null;
  } | null;
};
export type UpdateDeliverableMutation = {
  variables: UpdateDeliverableMutation$variables;
  response: UpdateDeliverableMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateDeliverablePayload",
    "kind": "LinkedField",
    "name": "updateDeliverable",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DeliverableTypeEdge",
        "kind": "LinkedField",
        "name": "deliverable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DeliverableType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "price",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoicedAmount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lockedRevenue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasBeenInvoiced",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasLockedRevenue",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateDeliverableMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateDeliverableMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "adc94df63fb0043d24eeb6b741968f3c",
    "id": null,
    "metadata": {},
    "name": "UpdateDeliverableMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateDeliverableMutation(\n  $input: UpdateDeliverableInput!\n) {\n  updateDeliverable(input: $input) {\n    deliverable {\n      node {\n        id\n        name\n        description\n        price\n        invoicedAmount\n        lockedRevenue\n        hasBeenInvoiced\n        hasLockedRevenue\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "08f9c7a5160d4bd9f75e7e8c4ab24f73";

export default node;
